import { makeAutoObservable, runInAction } from "mobx";

class StreamingStore {
  streamingPlugin = null;

  isReady = false;

  jsepData = null;

  streams = [];

  selectedStreamId = "";

  oldScreensArray = [];

  streamTracks = {
    mainAudio: null, // janusa101
    mainVideo: null, // janusv101
    miniVideos: {}, // janusv102-mini, janusv103-mini, etc.
    baseVideo: null, // janusv105-mini
    combinedAudio: null, // janusa110-meet
    combinedVideo: null, // janusv110-mini
  };

  constructor(rootStore, oldScreensArray) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.rootStore = rootStore;
    this.oldScreensArray = oldScreensArray;
  }

  attach() {
    if (!this.rootStore.janusInstance) return;

    this.rootStore.janusInstance.attach({
      plugin: "janus.plugin.streaming",
      success: (pluginHandle) => {
        this.streamingPlugin = pluginHandle;
        this.isReady = true;
        console.log("[StreamingStore] Streaming plugin attached successfully");
        this.fetchStreams();
      },
      onmessage: (msg, jsep) => {
        console.log("StreamingStore onmessage: ", msg, jsep);
        this.handleStreamingMessage(msg, jsep);
      },
      error: (error) => {
        console.error("[StreamingStore] Error attaching streaming plugin:", error);
        this.isReady = false;
      },
      onremotetrack: (track, mid, on) => {
        console.log("StreamingStore onremotetrack: track kind:", track.kind, "MID:", mid, "On:", on);
        if (on) {
          this.addTrack(mid, track);
        } else {
          this.removeTrack(mid, track);
        }
      },
      oncleanup: () => {
        console.log("[StreamingStore] Got a cleanup notification");
        this.resetTracks();
      },
    });
  }

  addTrack(mid, track) {
    runInAction(() => {
      console.log(mid);
      switch (mid) {
        case "a101":
          this.streamTracks.mainAudio = track;
          break;
        case "v101":
          this.streamTracks.mainVideo = track;
          break;
        case "v105-mini":
          this.streamTracks.baseVideo = track;
          break;
        case "a110-meet":
          this.streamTracks.combinedAudio = track;
          break;
        case "v110-mini":
          this.streamTracks.combinedVideo = track;
          break;
        default:
          if (mid === "v102-mini" || mid === "v103-mini") {
            this.streamTracks.miniVideos[mid] = track;
          }
          break;
      }
    });
  }

  removeTrack(mid) {
    runInAction(() => {
      switch (mid) {
        case "a101":
          this.streamTracks.mainAudio = null;
          break;
        case "v101":
          this.streamTracks.mainVideo = null;
          break;
        case "v105-mini":
          this.streamTracks.baseVideo = null;
          break;
        case "a110-meet":
          this.streamTracks.combinedAudio = null;
          break;
        case "v110-mini":
          this.streamTracks.combinedVideo = null;
          break;
        default:
          if (mid.includes("-mini")) {
            delete this.streamTracks.miniVideos[mid];
          }
          break;
      }
    });
  }

  resetTracks() {
    this.streamTracks = {
      mainAudio: null,
      mainVideo: null,
      miniVideos: {},
      baseVideo: null,
      combinedAudio: null,
      combinedVideo: null,
    };
  }

  fetchStreams() {
    if (!this.streamingPlugin) return;
    this.streamingPlugin.send({
      message: { request: "list" },
      success: (result) => {
        if (!result || !result.list) {
          console.error("No streams available!");
          return;
        }
        console.log("[StreamingStore] fetchStreams: result", result);
        runInAction(() => {
          this.streams = result.list;
        });
      },
      error: (error) => console.error("Error fetching streams:", error),
    });
  }

  selectStream(stream) {
    if (!this.streamingPlugin || !stream) return;
    console.log("[StreamingStore] Selecting stream.");
    this.streamingPlugin.send({ message: { request: "watch", id: stream.id, pin: "" } });

    // this.streamingPlugin.onremotetrack = (track, mid) => {
    //   console.log("selectStream trackHandler");
    //   this.trackHandler(track, mid, this.oldScreensArray);
    // };
  }

  startReceivingStream(jsep) {
    if (!this.streamingPlugin) {
      console.error("[StreamingStore] Streaming plugin not attached.");
      return;
    }
    if (!jsep || jsep.type !== "offer") {
      console.error("[StreamingStore] No valid JSEP offer available.", jsep);
      return;
    }
    console.log("[StreamingStore] Creating answer for JSEP offer.", jsep);

    this.streamingPlugin.createAnswer({
      jsep,
      media: { audioSend: false, videoSend: false }, // We don't send audio or video back
      success: (jsepAnswer) => {
        console.log("[StreamingStore] Successfully created answer.", jsepAnswer);
        this.streamingPlugin.send({ message: { request: "start" }, jsep: jsepAnswer });
      },
      error: (error) => {
        console.error("[StreamingStore] Error creating answer:", error);
      },
    });
  }

  handleStreamingMessage(msg, jsep) {
    if (msg.error_code) {
      console.error("Janus error:", msg.error);
      return;
    }

    this.jsepData = jsep;

    if (jsep && jsep.type === "offer") {
      this.startReceivingStream(jsep);
    }
  }

  detach() {
    if (!this.streamingPlugin) {
      console.warn("[StreamingStore] No streaming plugin to detach");
      return;
    }

    this.streamingPlugin.detach({
      success: () => {
        console.log("[StreamingStore] Successfully detached streaming plugin");
        this.isReady = false;
        this.streamingPlugin = null;
      },
      error: (error) => {
        console.error("[StreamingStore] Error detaching streaming plugin:", error);
      },
    });
  }
}

export default StreamingStore;
